import React from 'react'

export default function ErrorPage() {
  return (
    <div>존재하지 않는 페이지입니다.</div>
  )
}
